<main class="container">
  <form [formGroup]="produtoForm" class="formItem">
    <div class="product_data flex">
      <div class="rotate_text flex"><div class="rotate_item" style="font-weight: bold;">{{ 'Produtos' | translate}}</div></div>

      <div class="product_data__items">
        <div class="flex" style="align-items: center;">
          <div class="product_data__item_produto" style="font-weight: bold;">
            {{ 'Produto' | translate}}
          </div>
          <div class="product_data__item_posologia posologia_title_fix" style="font-weight: bold;">
            {{ 'Posologia' | translate}}
          </div>
        </div>

        <div class="product_data__items_scroll">
         <div class="flex" style="justify-content: flex-end; width: 94%; margin-bottom: 8px;">
          <button type="button" id="addProduto" class="submit flex gap-1" tabindex="-1" style="align-items: center; border: none;" (click)="addProdutoFirst()" [title]="'Adicionar Produto (Ctrl + Shift + P)' | translate">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="16"></line><line x1="8" y1="12" x2="16" y2="12"></line></svg>
            <span>{{ 'Adicionar Produto' | translate }}</span>
          </button>
        </div>
          <ng-container *ngFor="let produto of produtoForm.controls; let i = index" [formGroupName]="i">
            <div class="review-product-item" [ngClass]="{'produto-recusado': isProdutoRemovido(i)}">
              <label *ngIf="!isValid(i)" style="cursor: pointer; display: flex; align-items: center; justify-content: flex-start; font-weight: bold; color: #4caf50; font-size: 0.85em;">
                <input type="checkbox" tabindex="-1" style="transform: scale(1); cursor: pointer; width: auto; margin: 0 6px 0 2px;" [(ngModel)]="produtosValidados[i]" [ngModelOptions]="{standalone: true}" (change)="atualizarValidacao()"/>{{ 'Produto não encontrado na pesquisa.' | translate }}
             </label>
              <div class="flex gap-1" style="width: 100%; align-items: center;">
                <div class="product_data__item_produto">
                  <input type="text" formControlName="nome" #produtoNome id="produto_nome_{{i}}" class="review-input" [class.field-incomplete]="isProdutoManual(i) && campoIncompleto(i)" [placeholder]="'Produto' | translate" (input)="onNomeInput(i)" [readonly]="!isProdutoManual(i)" tabindex="-1" />
                </div>
                <div class="product_data__item_posologia">
                  <input type="text" formControlName="posologia" class="review-input" [placeholder]="'Posologia' | translate" [readonly]="!isProdutoManual(i)" tabindex="-1" />
                </div>
              </div>
              <div class="flex gap-1 status-row" [ngClass]="isProdutoRemovido(i) ? 'not-found' : getStatusClass(i)" 
                style="width: 94%; margin-top: 2px; padding: 6px; border-radius: 4px; align-items: center;">
                
                <ng-container *ngIf="isProdutoRemovido(i)">
                  <div style="display: flex; justify-content: space-between; width: 100%; align-items: center;">
                    <span class="status-text" style="font-weight: bold; font-size: 1.05em;">
                      {{ produtos.at(i).get('motivo_exclusao_produto')?.value | translate }}
                    </span>
                    <button type="button" class="addRemoveButton" *ngIf="podeDesfazer()" (click)="desfazerExclusao(i)" [title]="'Desfazer' | translate" style="margin-right: 5px;">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#e53935" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <polyline points="1 4 1 10 7 10"></polyline>
                        <path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"></path>
                      </svg>
                    </button>
                  </div>
                </ng-container>

                <ng-container *ngIf="!isProdutoRemovido(i)">
                  <span class="status-text" style="font-weight: bold; font-size: 1.05em;">{{ getProductStatus(i) | translate }}</span>
                  <ng-container *ngIf="isAmbiguous(i)">
                    <select formControlName="retorno_produto" #retornoProduto class="review-input" [class.field-incomplete]="campoIncompleto(i)" style="flex: 1; width: auto;" (keydown.enter)="abrirModalProdutoEnter($event, i)" id="retorno_produto_{{i}}" (change)="onAmbiguousChange(i)">
                      <option value="" disabled selected>{{ 'Selecione o produto' | translate }}</option>
                      <option *ngFor="let option of produtos.at(i).get('ConteudoProdFiltro')?.value" [value]="option">{{ option }}</option>
                    </select>
                    <button type="button" class="btn btn-primary" style="margin-left: 5px; padding: 2px 8px;" (click)="abrirModalProduto(i)" [title]="'Pesquisar produto' | translate">
                      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <circle cx="11" cy="11" r="8"></circle>
                        <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                      </svg>
                    </button>
                    <button type="button" class="addRemoveButton" (click)="removeProduto(i)" [disabled]="produtos.length < 2" [title]="'Remover' | translate">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#999999" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <circle cx="12" cy="12" r="10"></circle>
                        <line x1="8" y1="12" x2="16" y2="12"></line>
                      </svg>
                    </button>
                  </ng-container>
                  <ng-container *ngIf="isValid(i) || isNotFound(i) || isProdutoManual(i)">
                    <input type="text" formControlName="retorno_produto" #retornoProduto class="review-input" [class.field-incomplete]="campoIncompleto(i)" style="flex: 1; width: auto;" (keydown.space)="abrirModalProdutoSpace($event, i)" (keydown.enter)="abrirModalProdutoEnter($event, i, true)" id="retorno_produto_{{i}}" (input)="onRetornoProdutoInput(i)" />
                    <button type="button" class="btn btn-primary" style="margin-left: 5px; padding: 2px 8px;" (click)="abrirModalProduto(i, true)" [title]="'Pesquisar produto' | translate">
                      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <circle cx="11" cy="11" r="8"></circle>
                        <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                      </svg>
                    </button>
                   <button type="button" class="addRemoveButton" (click)="removeProduto(i)" [disabled]="produtos.length < 2" [title]="'Remover' | translate">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#999999" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <circle cx="12" cy="12" r="10"></circle>
                      <line x1="8" y1="12" x2="16" y2="12"></line>
                    </svg>
                  </button>
                  </ng-container>
                </ng-container>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </form>
</main>

<!-- Modal Pesquisa de Produto -->
<div class="modal modal1" tabindex="-1" role="dialog" *ngIf="isModalProdutoOpen">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header flex space-between">
        <h5 class="modal-title">{{ 'Pesquisar produto por similaridade' | translate}}</h5>
        <button type="button" class="close" aria-label="Close" (click)="fecharModalProduto()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="flex form filtros">
          <div class="form-group filtro" style="width: 100%;">
            <label>{{ 'Produto Selecionado' | translate}}: <strong>{{ produtoSelecionadoNome }}</strong></label>
          <input type="text" #pesquisaInput autofocus class="form-control" [(ngModel)]="pesquisaProduto" (input)="filtrarProdutos()" (keydown.shift.o)="openCombo($event)" (keydown.enter)="confirmarSelecaoCombo($event)" (keydown.ArrowDown)="openCombo($event)" [placeholder]="'Pesquisar produto...' | translate" [ngModelOptions]="{standalone: true}">
            <small style="color: #666; font-size: 11px; display: block; margin-top: 4px;">{{ 'Pressione Shift + O ou a Seta para Baixo para abrir a lista' | translate }}</small>
            <small style="color: #666; font-size: 11px; display: block; margin-top: 2px;">{{ 'Use Alt + Número para selecionar rapidamente' | translate }}</small>
          </div>
        </div>
        
        <div class="flex form filtros" *ngIf="listaProdutosFiltrada && listaProdutosFiltrada.length > 0" style="margin-top: 15px;">
          <div class="form-group filtro" style="width: 100%;">
            <div class="product-search-list" #productList tabindex="0" (keydown)="onListKeydown($event)">
              <div class="product-search-header">
                <span class="col-idx"></span>
                <span class="col-name">{{ 'Produto' | translate }}</span>
                <span class="col-nro">NRO_PRESEN</span>
              </div>
              <div class="product-search-item"
                   *ngFor="let prod of listaProdutosFiltrada; let i = index"
                   [class.selected]="produtoSelecionadoCombobox === i.toString()"
                   [attr.data-index]="i"
                   (click)="selectProductFromList(i, $event)">
                <span class="col-idx">{{ i }}</span>
                <span class="col-name">{{ prod.name || prod.nome }}</span>
                <span class="col-nro">{{ (prod.isNotFoundItem ? '' : prod.nro_presen) || '' }}</span>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="listaProdutosFiltrada?.length === 0" class="text-center" style="color: #999; padding: 10px; margin-top: 15px;">
          {{ 'Nenhum produto encontrado.' | translate}}
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal Remover Produto -->
<div class="modal modal1" tabindex="-1" role="dialog" *ngIf="isModalRemoverOpen">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header flex space-between">
        <h5 class="modal-title">{{ 'Remover produto' | translate}}</h5>
        <button type="button" class="close" aria-label="Close" (click)="fecharModalRemover()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="flex form filtros">
          <div class="form-group filtro" style="width: 100%;">
            <label>{{ 'Produto' | translate}}: <strong>{{ produtoRemoverNome }}</strong></label>
          </div>
        </div>
        <div class="flex form filtros" style="margin-top: 15px;">
          <div class="form-group filtro" style="width: 100%;">
            <label>{{ 'Motivo de exclusão' | translate}}:</label>
            <select class="form-control" [value]="motivoRemocaoSelecionado" (change)="onMotivoRemocaoSelecionado($event)">
              <option value="" disabled selected>{{ 'Selecione o motivo da exclusão...' | translate }}</option>
              <option *ngFor="let motivo of motivosRemocao" [value]="motivo">{{ motivo | translate }}</option>
            </select>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal Confirmar Exclusão de Produto Manual -->
<div class="modal modal1" tabindex="-1" role="dialog" *ngIf="isModalConfirmarExclusaoManualOpen">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header flex space-between">
        <h5 class="modal-title">{{ 'Confirmação' | translate}}</h5>
        <button type="button" class="close" aria-label="Close" (click)="fecharModalConfirmarExclusaoManual()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body" style="text-align: center; padding: 30px 20px;">
        <p style="font-size: 1.1em; margin-bottom: 25px; margin-top: 0;">{{ 'Tem certeza de que deseja remover este produto adicionado manualmente?' | translate }}</p>
        <div class="flex" style="justify-content: center; gap: 15px;">
          <button type="button" class="remove" (click)="fecharModalConfirmarExclusaoManual()">{{ 'Cancelar' | translate }}</button>
          <button type="button" class="submit" (click)="confirmarExclusaoManual()" #confirmarButtonManual>{{ 'Confirmar' | translate }}</button>
        </div>
      </div>
    </div>
  </div>
</div>
